import { configureStore, type ThunkAction, type Action } from '@reduxjs/toolkit'
import appReducer from './appSlice'
import { localizationReducer } from '../components/localize/localizeSlice'
import { etApi } from '../api/etApi'
import { priceCalculatorFormSlice } from '../components/priceCalculatorForm/PriceCalculatorFormSlice'


export const store = configureStore({
  reducer: {
    app: appReducer,
    localization: localizationReducer,
    priceCalculator: priceCalculatorFormSlice.reducer,
    [etApi.reducerPath]: etApi.reducer,
  },
    middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(etApi.middleware),
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
